var _path, _line, _line2, _line3, _circle, _path2, _g, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimitRules(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6836 21.9453H3.57617V93.4671H59.261V56.7396",
    stroke: "#16161E",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 48.5322,
    y1: 64.8262,
    x2: 14.304,
    y2: 64.8262,
    stroke: "#16161E",
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 48.5322,
    y1: 74.0215,
    x2: 14.304,
    y2: 74.0215,
    stroke: "#16161E",
    strokeWidth: 3
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 31.1631,
    y1: 82.7061,
    x2: 14.3044,
    y2: 82.706,
    stroke: "#16161E",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.3044,
    cy: 31.652,
    r: 30.1413,
    fill: "#AFFFD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0215 36.5059C23.0215 38.9221 21.0627 40.8809 18.6465 40.8809C16.2302 40.8809 14.2715 38.9221 14.2715 36.5059C14.2715 34.0896 16.2302 32.1309 18.6465 32.1309C21.0627 32.1309 23.0215 34.0896 23.0215 36.5059Z",
    stroke: "#16161E",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15329_27195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4629 12.7822V18.9713",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 28.6484H54.8809",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.585 35.0947H54.8814",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.127 41.2129H54.8804",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1801 38.2324C64.9639 38.2324 66.41 36.8053 66.41 35.0449C66.41 33.2845 64.9639 31.8574 63.1801 31.8574C61.3963 31.8574 59.9502 33.2845 59.9502 35.0449C59.9502 36.8053 61.3963 38.2324 63.1801 38.2324Z",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.374 32.7112L71.6178 26.79",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8223 46.7517C54.1183 48.9174 57.0042 50.3758 60.127 50.9483C63.2497 51.5208 66.4738 51.1826 69.4049 49.9751C72.3359 48.7676 74.8467 46.7432 76.6302 44.1496C78.4136 41.5559 79.3924 38.5055 79.4466 35.3715C79.5009 32.2375 78.6283 29.1558 76.9356 26.5035C75.243 23.8513 72.8037 21.7434 69.9161 20.4379C67.0286 19.1323 63.8181 18.6856 60.6773 19.1526C57.5366 19.6195 54.6019 20.9797 52.2322 23.0668",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0479 12.7822H69.3082",
    stroke: "#16161E",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15329_27195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 39.5294,
    fill: "white",
    transform: "translate(38 12.2354)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimitRules);
export default __webpack_public_path__ + "static/media/limit_rules.a062b1c1caa611318dfaae23bfff7c1a.svg";
export { ForwardRef as ReactComponent };